import { useState, useEffect } from 'react';
import { Box, Grid, Container, Typography } from '@mui/material';
// components
import Page from 'src/components/Page';
import {
  AppTasks,
  AppNewUsers,
  AppBugReports,
  AppItemOrders,
  AppNewsUpdate,
  AppWeeklySales,
  AppOrderTimeline,
  AppCurrentVisits,
  AppWebsiteVisits,
  AppTrafficBySite,
  AppCurrentSubject,
  AppConversionRates
} from 'src/components/_dashboard/app';
import { asyncRequest } from 'src/services/network';
import { useNavigate } from 'react-router';
import StatCell from 'src/components/_dashboard/app/StatCell';
import dayjs from 'dayjs';

// ----------------------------------------------------------------------

export default function OrderStats() {
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    monthMap: { orders: 0, revenue: 0 },
    weekMap: { orders: 0, revenue: 0 },
    yesterdayMap: { orders: 0, revenue: 0 },
    totalMap: { orders: 0, revenue: 0 }
  });

  useEffect(() => {
    getStats();
  }, []);

  async function getStats() {
    const { data } = await asyncRequest({
      method: 'get',
      path: '/order/stats'
    });

    let todayStart = dayjs().startOf('day').toDate().getTime();
    let todayEnd = dayjs().endOf('day').toDate().getTime();
    let yesterdayStart = dayjs().subtract(1, 'day').startOf('day').toDate().getTime();
    let yesterdayEnd = dayjs().subtract(1, 'day').endOf('day').toDate().getTime();
    let weekStart = dayjs().startOf('week').toDate();
    let weekEnd = dayjs().endOf('week').toDate();
    console.log(weekStart, weekEnd);

    let monthMap = { orders: 0, revenue: 0 };
    let weekMap = { orders: 0, revenue: 0 };
    let yesterdayMap = { orders: 0, revenue: 0 };
    let totalMap = { orders: 0, revenue: 0 };


    data.forEach(d => {
      const time = new Date(d.createdAt).getTime();
      // if (time >= yesterdayStart && time <= yesterdayEnd) {
      //   console.log(d)
      // }

      monthMap.orders += 1;
      monthMap.revenue += d.totalPrice;

      if (time >= weekStart) {
        weekMap.orders += 1;
        weekMap.revenue += d.totalPrice;

        if (time >= yesterdayStart) {
          if (time <= yesterdayEnd) {
            yesterdayMap.orders += 1;
            yesterdayMap.revenue += d.totalPrice;
          } else {
            totalMap.orders += 1;
            totalMap.revenue += d.totalPrice;
          }
        }
      }

    });

    setStats({
      monthMap,
      weekMap,
      yesterdayMap,
      totalMap
    });
  }


  return (
    <Page title="订单总览">
      <Container maxWidth="xl">
        <Box sx={{ pb: 5 }}>
          <Typography variant="h4">订单总览</Typography>
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            <StatCell title="今日成交量 / 销售额" num={`${stats.totalMap.orders} / ${stats.totalMap.revenue}元`} onClick={() => {
              navigate('/order/list')
            }} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCell title="昨日成交量 / 销售额" num={`${stats.yesterdayMap.orders} / ${stats.yesterdayMap.revenue}元`} onClick={() => {
              navigate('/order/list')
            }} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCell title="本周成交量 / 销售额" num={`${stats.weekMap.orders} / ${stats.weekMap.revenue}元`} onClick={() => {
              navigate('/order/list')
            }} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCell title="本月成交量 / 销售额" num={`${stats.monthMap.orders} / ${stats.monthMap.revenue}元`} onClick={() => {
              navigate('/order/list')
            }} />
          </Grid>

          {/* <Grid item xs={12} md={6} lg={8}>
            <AppWebsiteVisits />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppCurrentVisits />
          </Grid> */}

          {/* <Grid item xs={12} md={6} lg={8}>
            <AppConversionRates />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppCurrentSubject />
          </Grid> */}

          {/* <Grid item xs={12} md={6} lg={8}>
            <AppNewsUpdate />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppOrderTimeline />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppTrafficBySite />
          </Grid>

          <Grid item xs={12} md={6} lg={8}>
            <AppTasks />
          </Grid> */}

        </Grid>
      </Container>
    </Page>
  );
}
